import { IconButton, Typography, Box } from "@mui/material";
import { purple, white } from "../../../../theme/colours";
import { useContext } from "react";
import { GlobalContext } from "../../Context";

const NavButton = ({ name, text, activeButton, handleClick, icon }) => {
  const { desktopView } = useContext(GlobalContext);

  const navButtonStyle = {
    display: "flex",
    mb: "2%",
    "&:hover": {
      cursor: "pointer",
      fill: "#fefffe",
      filter: "drop-shadow(1px 2px 3px #c6c4cb)",
    },
    mr: "1.5rem",
    alignItems: "center",
    "&:last-child": {
      mb: "4%",
    },
  };
  const activeButtonStyle = {
    backgroundColor: purple[1],
    "&:hover": {
      backgroundColor: purple[1],
    },
    "& svg *": {
      fill: white,
    },
  };
  const buttonStyle = {
    height: "2.1em",
    width: "2.1em",
    justifyContent: "flex-start",
    m: "0.5rem 1rem",
    p: "0.75rem",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "& svg": {
      width: "100%",
    },
    "& svg *": {
      fill: purple[1],
    },
    boxShadow: "#2f085f39 0px 3px 20px",
    ...(activeButton === name && {
      ...activeButtonStyle,
    }),
    ...(desktopView && {
      mr: "1.5rem",
    }),
  };
  const activeTextStyle = {
    color: purple[1],
  };
  const textStyle = {
    fontSize: "16px",
    textTransform: "capitalize",
    fontWeight: 700,
    overflow: "hidden",
    "text-overflow": "clip",
    "white-space": "nowrap",
    ...(activeButton === name && {
      ...activeTextStyle,
    }),
  };

  return (
    <Box sx={navButtonStyle} onClick={() => handleClick(name)} id={name}>
      <IconButton onClick={() => handleClick(name)} sx={buttonStyle}>
        {icon}
      </IconButton>
      <Typography sx={textStyle} variant="h4">
        {text}
      </Typography>
    </Box>
  );
};

export default NavButton;
